import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileUploadApiService } from '../../services/api/file-upload-api.service';
import { IToastr } from '../../types/toastr';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { HttpErrorResponse } from '@angular/common/http';
import { FileDocument } from '../../types/file-document';

declare const toastr: IToastr;

@Component({
    selector: 'file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.scss']
})
export class FileUploadComponent implements OnInit {

    @Input() hint = 'Click here to upload a file';

    @Input() supportedFileTypes: string[] = [];

    @Output() onFileUploaded: EventEmitter<FileDocument> = new EventEmitter();

    isFileOver: boolean = false;

    constructor(
        private uploadService: FileUploadApiService
    ) {
    }

    ngOnInit() {
    }

    onFileDrop(file: File) {
        this.uploadFile(file);
    }

    fileOver(isOver: boolean) {
        this.isFileOver = isOver;
    }

    onFileChange(event) {
        this.uploadFile(event.target.files[0]);
    }

    /**
     * Upload file
     * and emit file URL on success
     *
     * @param file
     */
    uploadFile(file: File) {
        if (!this.validateFile(file)) {
            toastr.error(`Allowed file types: ${this.supportedFileTypes.join(', ')}`, 'Unsupported file type');
            return;
        }

        this.uploadService.fileUpload(file).pipe(
            catchError((error: HttpErrorResponse) => {
                toastr.error(error.statusText, 'File upload failed');

                return Observable.throw(error);
            })
        ).subscribe(fileUrl => this.onFileUploaded.emit(fileUrl));
    }

    /**
     * Check if file supported
     * @param file
     */
    private validateFile(file: File): boolean {
        if (!this.supportedFileTypes || !this.supportedFileTypes.length) {

            return true;
        }

        const fileType = file.name.split('.').pop();

        return this.supportedFileTypes.includes(fileType);
    }
}



// WEBPACK FOOTER //
// /app/src/app/components/file-upload/file-upload.component.ts